import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="Not Found"
      subTitle="The page you are looking for doesn’t exist."
      extra={
        <Button type="primary" onClick={() => navigate('/sites')}>
          Go to Sites
        </Button>
      }
    />
  );
}
